// extracted by mini-css-extract-plugin
module.exports = {"image":"CarrierImage_image__2FEXK"};